import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Routing from './components/Routing';
import Icons from './components/Icons';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Routing></Routing>
    <Icons></Icons>
  </React.StrictMode>
);
reportWebVitals();
